import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import useFetchData from '../../hooks/ValuatorHooks/useFetchData'; 
import { where } from 'firebase/firestore';
import useNavigation from '../../hooks/useNavigation';
import '../../Styles/ValuatorStyles/WorkerList.css';
import { useWorker } from '../../contexts/WorkerContext';
import AdminDropdown from '../AdminDropDown';
import useFetchCompanies from '../../hooks/useFetchCompanies';
import { useSelectedCompany } from '../../contexts/SelectedCompanyContext';


const WorkerList = () => {
  const { selectedCompany, setSelectedCompany } = useSelectedCompany();
  const {companies, loading: isCompanyLoading, error: companyError} = useFetchCompanies();
  const { setCurrentWorker } = useWorker();
  const { navigateTo } = useNavigation();
  const workerQueryParams = useMemo(() => {
    const params = [where("userType", "==", "worker")];
    if (selectedCompany) {
      params.push(where("company", "==", selectedCompany));
    }
    return params;
}, [selectedCompany]);

  const { data: workers, loading, error } = useFetchData("users", null, workerQueryParams);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading workers: {error}</div>;

  const handleBackBtn = () => {
    navigateTo('/valuator');
  }
  
  return (
    <div className="container worker-list-container">
    <h2 className="main-header">Workers</h2>
    <AdminDropdown
          allCompanies={companies}
          setSelectedCompany={setSelectedCompany}
          selectedCompany={selectedCompany}>            
        </AdminDropdown>
    <button onClick={handleBackBtn} className="back-btn">Tilbage til dashboard</button>
    <div className="worker-list-content">
        <ul className="worker-list-ul">
          <h2 className='sub-header'>Liste over medarbejdere</h2>
        {workers && Array.isArray(workers) && workers.map((worker) => (
          <li className='worker-list-li' onClick={() => setCurrentWorker(worker)} key={worker.id}>
          <Link to={`${worker.id}`}>{worker.name}</Link>
        </li>
        ))}
      </ul>
    </div>
  </div>
  );
};
export default WorkerList;

